import { useState } from "react"

// Explicit save: call save() with the draft when the user clicks Save.
// Returns whether it stuck, so the caller decides what to do with the UI.
// A failure goes quiet rather than scolding; the draft stays put so the
// user can just hit Save again.
export function useSave(onSave?: (body: string) => Promise<boolean>): {
  saving: boolean
  save: (body: string) => Promise<boolean>
} {
  const [saving, setSaving] = useState(false)

  async function save(body: string): Promise<boolean> {
    if (!onSave) return false
    setSaving(true)
    const ok = await onSave(body)
    setSaving(false)
    return ok
  }

  return { saving, save }
}

// Sample files aren't persisted anywhere; every real file saves silently.
export function saveNote(savable: boolean): string {
  return savable ? "" : "Sample file — edits aren't saved yet"
}
